import GeometryEditor from './GeometryEditor/EditorDialog'
import ExampleTool from './ExampleTool';
import RouteEditor from './RouteEditor/RouteEditorDialog';
import ExportKmlTool from './ExportKml/ExportKmlTool';




const plugins = [
  // {
  //   toolname: "ExampleTool",
  //   toolversion: "0.1.0",
  //   description: "ExampleTool",
  //   tool_component: ExampleTool
  // },
  {
    toolname: "Editor",
    toolversion: "0.1.0",
    description: "Create and edit map features including points, lines, and polygons with interactive editing tools.",
    tool_component: GeometryEditor
  },
  {
    toolname: "Route Editor",
    toolversion: "0.1.0",
    description: "Build routes by placing waypoints. Drag to reroute via OSRM.",
    tool_component: RouteEditor
  },
  {
    toolname: "Export KML",
    toolversion: "0.1.0",
    description: "Export a layer as a KML file.",
    tool_component: ExportKmlTool
  }
  // {
  //   toolname: "Ring Importer",
  //   toolversion: "0.1.0",
  //   description: "Imports pre-planned route to system netive format",
  //   tool_component: ExampleTool
  // },
  // {
  //   toolname: "Layer Exporter",
  //   toolversion: "0.1.0",
  //   description: "Exports layer to desired geospatial formats",
  //   tool_component: ExampleTool
  // },
  // {
  //   toolname: "Muti Ring Generator",
  //   toolversion: "0.1.0",
  //   description: "plans Muti Ring throuth waypoints",
  //   tool_component: ExampleTool
  // },
  // {
  //   toolname: "Conflict Resolver",
  //   toolversion: "0.1.0",
  //   description: "Manual layer conflict resolver tool",
  //   tool_component: ExampleTool
  // },
];

export default plugins;